import { Component, OnInit } from '@angular/core';
import { TelephoneNumber } from 'app/models/telephone-number';
import { AccountService } from '../../../services/account.service';
import { Router } from '@angular/router';
import { ErrorService } from 'services/error.service';

@Component({
  selector: 'app-forgot-email',
  templateUrl: './forgot-email.component.html',
  styleUrls: ['./forgot-email.component.css']
})
export class ForgotEmailComponent implements OnInit {

  cellPhone: TelephoneNumber;
  constructor(public router: Router, public accountService: AccountService, private errorService: ErrorService) { }

  ngOnInit(): void {
  }

  onSubmit = () => {
    this.accountService.requestEmailReminder(this.cellPhone?.format()).subscribe(x => this.redirect());
  }

  redirect = () => {
    this.errorService.showMessage("Thank you. If your phone number is registered with us, you will receive a text message with your login email within the next 60 seconds.");
    this.router.navigate(['/public/login']);
  }

}
